<script lang="ts"></script>

<script setup lang="ts">
/**
 * 🅲🅾🅼🅿🅾🅽🅴🅽🆃 [Modal]
 * Модальное окно / обертка
 */

import CloseMenu from "@/components/closeMenu/closeMenu.vue";
// Store
import { useTIWStore } from "@/stores/tiw/tiw";
// Components
import Button from "@/ui/button/button.vue";
import BreezyIcon from "@/ui/icons/breezy.vue";
// Icon
import CloseIcon from "@/ui/icons/close.vue";
import useTranslate from "~/tiw/hooks/useTranslate/useTranslate";

function openCrunch() {
    HelpCrunch("openChat");
}

const TIWStore = useTIWStore();
</script>

<template>
    <section class="tiw__step-wrapper">
        <Button variant="unset" class="tiw__step-wrapper__close">
            <CloseIcon />
        </Button>
        <CloseMenu />
        <div class="tiw__step-wrapper__header">
            <slot name="header" />
        </div>
        <div class="tiw__step-wrapper__content">
            <slot />
        </div>
        <div v-if="TIWStore.showHelpCrunchChat" class="tiw__footer__help">
            <svg
                width="46"
                height="46"
                viewBox="0 0 50 50"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M44 18.3333C42.145 9.035 33.5303 2 23.1867 2C11.4827 2 2 10.995 2 22.09C2 27.4217 4.18867 32.2633 7.761 35.8567C8.545 36.65 9.07 37.7303 8.85767 38.8433C8.5127 40.6532 7.72197 42.3486 6.557 43.776C9.61007 44.3292 12.7605 43.8437 15.5053 42.397C16.4667 41.8883 16.9497 41.6363 17.288 41.585C17.526 41.5477 17.8363 41.5827 18.3333 41.6667"
                    stroke="#808D9A"
                    stroke-width="2.4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M35.0005 48.001C42.1805 48.001 48.001 42.1805 48.001 35.0005C48.001 27.8205 42.1805 22 35.0005 22C27.8205 22 22 27.8205 22 35.0005C22 42.1805 27.8205 48.001 35.0005 48.001Z"
                    stroke="#E06A00"
                    stroke-width="2.4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M31.75 31.7509C31.7502 31.191 31.8951 30.6406 32.1705 30.1531C32.446 29.6656 32.8427 29.2576 33.3222 28.9685C33.8018 28.6795 34.3479 28.5192 34.9075 28.5033C35.4672 28.4873 36.0215 28.6162 36.5168 28.8775C37.012 29.1388 37.4313 29.5236 37.7341 29.9946C38.0368 30.4656 38.2128 31.0068 38.2449 31.5658C38.277 32.1248 38.1641 32.6826 37.9173 33.1851C37.6704 33.6877 37.2978 34.1179 36.8358 34.4342C35.9466 35.0426 35.0001 35.8746 35.0001 36.9511"
                    stroke="#E06A00"
                    stroke-width="2.4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M35 41.501H35.0112"
                    stroke="#E06A00"
                    stroke-width="2.4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>

            <div class="tiw__footer__help__textBlock">
                <p class="tiw__footer__help__textBlock__title">
                    {{ useTranslate("tiw__crunch__needHelp") }}
                </p>
                <p class="tiw__footer__help__textBlock__text">
                    {{ useTranslate("tiw__crunch__contactUs") }}
                    <Button as="span" variant="link" color="link" @click="openCrunch">
                        {{ useTranslate("tiw__crunch__contactUsAfter") }}
                    </Button>
                </p>
            </div>
        </div>
        <footer v-if="!TIWStore.IS_INIT_WIDGET_LOADING" class="tiw__step-wrapper__footer">
            <div class="footer-cont">
                <span>{{ useTranslate("tiw__modal__serviceProvide") }}</span>
                <BreezyIcon />
            </div>
        </footer>
    </section>
</template>

<style lang="scss" src="./modal.scss"></style>
